export const translations = {
  en: {
    // Onboarding
    welcome: "Welcome to Global Chat Connect",
    welcomeSubtitle: "Break language barriers with auto-translated messaging",
    selectLanguage: "Select Your Preferred Language",
    languageHint: "All messages will be automatically translated to this language",
    continue: "Continue",
    
    // Auth
    signIn: "Sign In",
    signUp: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Name",
    phone: "Phone Number",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    signingIn: "Signing in...",
    signingUp: "Signing up...",
    agreeToTerms: "I agree to the",
    termsAndPrivacy: "Terms and Privacy Policy",
    forgotPassword: "Forgot Password?",
    forgotPasswordHint: "Enter your email and we'll send you a reset link",
    sendResetLink: "Send Reset Link",
    sending: "Sending...",
    resetEmailSent: "Password reset email sent! Check your inbox.",
    invalidResetLink: "Invalid or expired password reset link.",
    setNewPassword: "Set New Password",
    setNewPasswordHint: "Enter your new password below",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordsDoNotMatch: "Passwords do not match.",
    passwordTooShort: "Password must be at least 6 characters.",
    passwordUpdated: "Password updated successfully!",
    updating: "Updating...",
    updatePassword: "Update Password",
    phoneAlreadyInUse: "This phone number is already registered. Please use a different number.",
    
    // Chat List
    chats: "Chats",
    noChats: "No chats yet",
    startChatting: "Start a conversation by adding a contact",
    deleteChat: "Delete Chat",
    deleteChatConfirm: "Are you sure you want to delete this chat? This action cannot be undone.",
    pinChat: "Pin",
    unpinChat: "Unpin",
    muteChat: "Mute",
    unmuteChat: "Unmute",
    chatMuted: "Muted",
    pinnedChats: "Pinned",
    archiveChat: "Archive",
    unarchiveChat: "Unarchive",
    archivedChats: "Archived",
    showArchived: "Show archived",
    hideArchived: "Hide archived",
    noArchivedChats: "No archived chats",
    
    // Chat Screen
    typeMessage: "Type a message...",
    send: "Send",
    online: "Online",
    offline: "Offline",
    lastSeen: "Last seen",
    typing: "is typing...",
    typingPlural: "are typing...",
    andOthers: "and {count} more",
    showOriginal: "Show original",
    showTranslated: "Show translated",
    translatedFrom: "Translated from {language}",
    groupMembers: "Group Members",
    addMembers: "Add Members",
    removeMember: "Remove",
    searchMessages: "Search messages...",
    noMessagesFound: "No messages found",
    reply: "Reply",
    replyingTo: "Replying to",
    forwardMessage: "Forward Message",
    forward: "Forward",
    messageForwarded: "Message forwarded",
    deleteMessage: "Delete Message",
    deleteMessageConfirm: "Are you sure you want to delete this message? This action cannot be undone.",
    messageDeleted: "Message deleted",
    editMessage: "Edit Message",
    editMessageHint: "Edit your message below. The translation will be updated automatically.",
    messageEdited: "Message edited",
    edited: "edited",
    
    // Add Contact
    addContact: "Add Contact",
    enterPhoneNumber: "Enter phone number",
    phoneNumberHint: "Enter their phone number. If they're already on the app, you'll be connected instantly. If not, we'll send them a warm invitation.",
    searching: "Searching...",
    userFound: "User found! Starting chat...",
    userNotFound: "Not on Global Chat Connect yet.",
    sendInvite: "Send Invitation",
    inviteSent: "Invitation sent! 🎉",
    invitePageTitle: "Invite Someone",
    invitePreviewHeader: "They'll receive this message:",
    startChattingButton: "Start Chatting",
    alreadyOnApp: "Already on Global Chat Connect!",
    invitationPending: "Invitation sent",
    resendInvite: "Resend",
    resending: "Resending...",
    inviteResent: "Invitation resent!",
    cancelInvite: "Cancel Invitation",
    cancelInviteConfirm: "Are you sure you want to cancel this invitation?",
    inviteCancelled: "Invitation cancelled",
    
    // Create Group
    createGroup: "Create Group",
    groupName: "Group Name",
    groupNamePlaceholder: "Enter group name",
    selectMembers: "Select Members",
    noContactsYet: "No contacts yet",
    create: "Create",
    creating: "Creating...",
    
    // Settings
    settings: "Settings",
    profile: "Profile",
    profileImage: "Profile Image",
    changePhoto: "Change Photo",
    takePhoto: "Take Photo",
    chooseFromGallery: "Choose from Gallery",
    preferredLanguage: "Preferred Language",
    appearance: "Appearance",
    theme: "Theme",
    lightMode: "Light",
    darkMode: "Dark",
    subscription: "Subscription",
    manageSubscription: "Manage Subscription",
    cancelSubscription: "Cancel Subscription",
    cancelSubscriptionConfirm: "Are you sure you want to cancel your subscription?",
    restorePurchases: "Restore Purchases",
    restoring: "Restoring...",
    restoreSuccess: "Purchases restored successfully!",
    deleteAccount: "Delete Account",
    deleteAccountConfirm: "Are you sure you want to delete your account? This action cannot be undone and all your data will be permanently deleted.",
    signOut: "Sign Out",
    save: "Save",
    saving: "Saving...",
    
    // Subscription
    subscribe: "Subscribe",
    subscribeTo: "Subscribe to Global Chat Connect",
    subscriptionBenefits: "Unlock unlimited messaging and group chats",
    freeTrial: "Start 3-Day Free Trial",
    monthly: "Monthly",
    yearly: "Yearly",
    lifetime: "Lifetime",
    perMonth: "/month",
    perYear: "/year",
    oneTime: "one-time",
    mostPopular: "Most Popular",
    bestValue: "Best Value",
    currentPlan: "Current Plan",
    subscribedUntil: "Subscribed until",
    trialEnds: "Trial ends",
    trialDayOf: "Day {day} of 3",
    translationPaused: "Translation paused",
    translationPausedDesc: "Your free trial has ended. Messages are still arriving in their original language.",
    unlockTranslation: "Unlock Translation",
    continueWithoutTranslation: "Continue without translation",
    textSize: "Text Size",
    normalText: "Normal",
    largeText: "Large",

    // Common
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    done: "Done",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    retry: "Retry",
    back: "Back",
    next: "Next",
    search: "Search",
    noResults: "No results found",
    searchGifs: "Search GIFs...",
    loadMore: "Load more",
    gif: "GIF",
    
    // Errors
    errorOccurred: "An error occurred",
    tryAgain: "Please try again",
    networkError: "Network error. Please check your connection.",
    sessionExpired: "Session expired. Please sign in again.",
    
    // Privacy
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
  },
  
  es: {
    welcome: "Bienvenido a Global Chat Connect",
    welcomeSubtitle: "Rompe las barreras del idioma con mensajes traducidos automáticamente",
    selectLanguage: "Selecciona tu idioma preferido",
    languageHint: "Todos los mensajes se traducirán automáticamente a este idioma",
    continue: "Continuar",
    signIn: "Iniciar sesión",
    signUp: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    phone: "Número de teléfono",
    createAccount: "Crear cuenta",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    dontHaveAccount: "¿No tienes una cuenta?",
    signingIn: "Iniciando sesión...",
    signingUp: "Registrando...",
    agreeToTerms: "Acepto los",
    termsAndPrivacy: "Términos y Política de Privacidad",
    forgotPassword: "¿Olvidaste tu contraseña?",
    forgotPasswordHint: "Ingresa tu correo y te enviaremos un enlace para restablecer",
    sendResetLink: "Enviar enlace",
    sending: "Enviando...",
    resetEmailSent: "¡Correo enviado! Revisa tu bandeja de entrada.",
    invalidResetLink: "Enlace de restablecimiento inválido o expirado.",
    setNewPassword: "Establecer nueva contraseña",
    setNewPasswordHint: "Ingresa tu nueva contraseña abajo",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    passwordsDoNotMatch: "Las contraseñas no coinciden.",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres.",
    passwordUpdated: "¡Contraseña actualizada exitosamente!",
    updating: "Actualizando...",
    updatePassword: "Actualizar contraseña",
    phoneAlreadyInUse: "Este número de teléfono ya está registrado. Por favor, usa un número diferente.",
    chats: "Chats",
    noChats: "Aún no hay chats",
    startChatting: "Inicia una conversación agregando un contacto",
    deleteChat: "Eliminar chat",
    deleteChatConfirm: "¿Estás seguro de que quieres eliminar este chat? Esta acción no se puede deshacer.",
    pinChat: "Fijar",
    unpinChat: "Desfijar",
    muteChat: "Silenciar",
    unmuteChat: "Activar",
    chatMuted: "Silenciado",
    pinnedChats: "Fijados",
    typeMessage: "Escribe un mensaje...",
    send: "Enviar",
    online: "En línea",
    offline: "Desconectado",
    lastSeen: "Última vez",
    typing: "está escribiendo...",
    typingPlural: "están escribiendo...",
    andOthers: "y {count} más",
    showOriginal: "Mostrar original",
    showTranslated: "Mostrar traducido",
    translatedFrom: "Traducido del {language}",
    groupMembers: "Miembros del grupo",
    addMembers: "Agregar miembros",
    removeMember: "Eliminar",
    searchMessages: "Buscar mensajes...",
    noMessagesFound: "No se encontraron mensajes",
    reply: "Responder",
    replyingTo: "Respondiendo a",
    forwardMessage: "Reenviar mensaje",
    forward: "Reenviar",
    messageForwarded: "Mensaje reenviado",
    deleteMessage: "Eliminar mensaje",
    deleteMessageConfirm: "¿Estás seguro de que deseas eliminar este mensaje? Esta acción no se puede deshacer.",
    messageDeleted: "Mensaje eliminado",
    editMessage: "Editar mensaje",
    editMessageHint: "Edita tu mensaje a continuación. La traducción se actualizará automáticamente.",
    messageEdited: "Mensaje editado",
    edited: "editado",
    addContact: "Agregar contacto",
    enterPhoneNumber: "Ingresa el número de teléfono",
    phoneNumberHint: "Ingresa su número de teléfono. Si ya usan la app, estarás conectado al instante. Si no, les enviaremos una invitación.",
    searching: "Buscando...",
    userFound: "¡Usuario encontrado! Iniciando chat...",
    userNotFound: "Aún no está en Global Chat Connect.",
    sendInvite: "Enviar invitación",
    inviteSent: "¡Invitación enviada! 🎉",
    invitationPending: "Invitación enviada",
    resendInvite: "Reenviar",
    resending: "Reenviando...",
    inviteResent: "¡Invitación reenviada!",
    cancelInvite: "Cancelar invitación",
    cancelInviteConfirm: "¿Seguro que quieres cancelar esta invitación?",
    inviteCancelled: "Invitación cancelada",
    createGroup: "Crear grupo",
    groupName: "Nombre del grupo",
    groupNamePlaceholder: "Ingresa el nombre del grupo",
    selectMembers: "Seleccionar miembros",
    noContactsYet: "Aún no hay contactos",
    create: "Crear",
    creating: "Creando...",
    settings: "Configuración",
    profile: "Perfil",
    profileImage: "Imagen de perfil",
    changePhoto: "Cambiar foto",
    takePhoto: "Tomar foto",
    chooseFromGallery: "Elegir de la galería",
    preferredLanguage: "Idioma preferido",
    appearance: "Apariencia",
    theme: "Tema",
    lightMode: "Claro",
    darkMode: "Oscuro",
    subscription: "Suscripción",
    manageSubscription: "Administrar suscripción",
    cancelSubscription: "Cancelar suscripción",
    cancelSubscriptionConfirm: "¿Estás seguro de que quieres cancelar tu suscripción?",
    restorePurchases: "Restaurar compras",
    restoring: "Restaurando...",
    restoreSuccess: "¡Compras restauradas con éxito!",
    deleteAccount: "Eliminar cuenta",
    deleteAccountConfirm: "¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer y todos tus datos se eliminarán permanentemente.",
    signOut: "Cerrar sesión",
    save: "Guardar",
    saving: "Guardando...",
    subscribe: "Suscribirse",
    subscribeTo: "Suscríbete a Global Chat Connect",
    subscriptionBenefits: "Desbloquea mensajes ilimitados y chats grupales",
    freeTrial: "Comenzar prueba gratuita de 3 días",
    monthly: "Mensual",
    yearly: "Anual",
    lifetime: "Vitalicio",
    perMonth: "/mes",
    perYear: "/año",
    oneTime: "pago único",
    mostPopular: "Más popular",
    bestValue: "Mejor valor",
    currentPlan: "Plan actual",
    subscribedUntil: "Suscrito hasta",
    trialEnds: "La prueba termina",
    trialDayOf: "Día {day} de 3",
    translationPaused: "Traducción pausada",
    translationPausedDesc: "Tu prueba gratuita ha terminado. Los mensajes siguen llegando en su idioma original.",
    unlockTranslation: "Desbloquear traducción",
    continueWithoutTranslation: "Continuar sin traducción",
    textSize: "Tamaño del texto",
    normalText: "Normal",
    largeText: "Grande",
    cancel: "Cancelar",
    confirm: "Confirmar",
    delete: "Eliminar",
    edit: "Editar",
    done: "Listo",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    retry: "Reintentar",
    back: "Atrás",
    next: "Siguiente",
    search: "Buscar",
    noResults: "No se encontraron resultados",
    searchGifs: "Buscar GIFs...",
    loadMore: "Cargar más",
    gif: "GIF",
    errorOccurred: "Ocurrió un error",
    tryAgain: "Por favor, inténtalo de nuevo",
    networkError: "Error de red. Por favor, verifica tu conexión.",
    sessionExpired: "Sesión expirada. Por favor, inicia sesión de nuevo.",
    privacyPolicy: "Política de privacidad",
    termsOfUse: "Términos de uso",
  },
  
  fr: {
    welcome: "Bienvenue sur Global Chat Connect",
    welcomeSubtitle: "Brisez les barrières linguistiques avec la messagerie traduite automatiquement",
    selectLanguage: "Sélectionnez votre langue préférée",
    languageHint: "Tous les messages seront automatiquement traduits dans cette langue",
    continue: "Continuer",
    signIn: "Se connecter",
    signUp: "S'inscrire",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom",
    phone: "Numéro de téléphone",
    createAccount: "Créer un compte",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    signingIn: "Connexion...",
    signingUp: "Inscription...",
    agreeToTerms: "J'accepte les",
    termsAndPrivacy: "Conditions et Politique de confidentialité",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordHint: "Entrez votre e-mail et nous vous enverrons un lien de réinitialisation",
    sendResetLink: "Envoyer le lien",
    sending: "Envoi...",
    resetEmailSent: "E-mail envoyé ! Vérifiez votre boîte de réception.",
    invalidResetLink: "Lien de réinitialisation invalide ou expiré.",
    setNewPassword: "Définir un nouveau mot de passe",
    setNewPasswordHint: "Entrez votre nouveau mot de passe ci-dessous",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas.",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères.",
    passwordUpdated: "Mot de passe mis à jour avec succès !",
    updating: "Mise à jour...",
    updatePassword: "Mettre à jour le mot de passe",
    phoneAlreadyInUse: "Ce numéro de téléphone est déjà enregistré. Veuillez utiliser un autre numéro.",
    chats: "Discussions",
    noChats: "Pas encore de discussions",
    startChatting: "Commencez une conversation en ajoutant un contact",
    deleteChat: "Supprimer la discussion",
    deleteChatConfirm: "Êtes-vous sûr de vouloir supprimer cette discussion ? Cette action ne peut pas être annulée.",
    pinChat: "Épingler",
    unpinChat: "Désépingler",
    muteChat: "Désactiver",
    unmuteChat: "Activer",
    chatMuted: "Désactivé",
    pinnedChats: "Épinglés",
    typeMessage: "Tapez un message...",
    send: "Envoyer",
    online: "En ligne",
    offline: "Hors ligne",
    lastSeen: "Dernière connexion",
    typing: "écrit...",
    typingPlural: "écrivent...",
    andOthers: "et {count} autres",
    showOriginal: "Afficher l'original",
    showTranslated: "Afficher la traduction",
    translatedFrom: "Traduit du {language}",
    groupMembers: "Membres du groupe",
    addMembers: "Ajouter des membres",
    removeMember: "Retirer",
    searchMessages: "Rechercher des messages...",
    noMessagesFound: "Aucun message trouvé",
    reply: "Répondre",
    replyingTo: "En réponse à",
    forwardMessage: "Transférer le message",
    forward: "Transférer",
    messageForwarded: "Message transféré",
    deleteMessage: "Supprimer le message",
    deleteMessageConfirm: "Êtes-vous sûr de vouloir supprimer ce message ? Cette action est irréversible.",
    messageDeleted: "Message supprimé",
    editMessage: "Modifier le message",
    editMessageHint: "Modifiez votre message ci-dessous. La traduction sera mise à jour automatiquement.",
    messageEdited: "Message modifié",
    edited: "modifié",
    addContact: "Ajouter un contact",
    enterPhoneNumber: "Entrez le numéro de téléphone",
    phoneNumberHint: "Entrez leur numéro de téléphone. S'ils utilisent déjà l'app, vous serez connectés instantanément. Sinon, nous leur enverrons une invitation.",
    searching: "Recherche...",
    userFound: "Utilisateur trouvé ! Démarrage de la discussion...",
    userNotFound: "Pas encore sur Global Chat Connect.",
    sendInvite: "Envoyer l'invitation",
    inviteSent: "Invitation envoyée ! 🎉",
    invitationPending: "Invitation envoyée",
    resendInvite: "Renvoyer",
    resending: "Renvoi...",
    inviteResent: "Invitation renvoyée !",
    cancelInvite: "Annuler l'invitation",
    cancelInviteConfirm: "Voulez-vous vraiment annuler cette invitation ?",
    inviteCancelled: "Invitation annulée",
    createGroup: "Créer un groupe",
    groupName: "Nom du groupe",
    groupNamePlaceholder: "Entrez le nom du groupe",
    selectMembers: "Sélectionner les membres",
    noContactsYet: "Pas encore de contacts",
    create: "Créer",
    creating: "Création...",
    settings: "Paramètres",
    profile: "Profil",
    profileImage: "Image de profil",
    changePhoto: "Changer la photo",
    takePhoto: "Prendre une photo",
    chooseFromGallery: "Choisir dans la galerie",
    preferredLanguage: "Langue préférée",
    appearance: "Apparence",
    theme: "Thème",
    lightMode: "Clair",
    darkMode: "Sombre",
    subscription: "Abonnement",
    manageSubscription: "Gérer l'abonnement",
    cancelSubscription: "Annuler l'abonnement",
    cancelSubscriptionConfirm: "Êtes-vous sûr de vouloir annuler votre abonnement ?",
    restorePurchases: "Restaurer les achats",
    restoring: "Restauration...",
    restoreSuccess: "Achats restaurés avec succès !",
    deleteAccount: "Supprimer le compte",
    deleteAccountConfirm: "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action ne peut pas être annulée et toutes vos données seront définitivement supprimées.",
    signOut: "Se déconnecter",
    save: "Enregistrer",
    saving: "Enregistrement...",
    subscribe: "S'abonner",
    subscribeTo: "Abonnez-vous à Global Chat Connect",
    subscriptionBenefits: "Débloquez la messagerie illimitée et les discussions de groupe",
    freeTrial: "Commencer l'essai gratuit de 3 jours",
    monthly: "Mensuel",
    yearly: "Annuel",
    lifetime: "À vie",
    perMonth: "/mois",
    perYear: "/an",
    oneTime: "paiement unique",
    mostPopular: "Le plus populaire",
    bestValue: "Meilleur rapport qualité-prix",
    currentPlan: "Plan actuel",
    subscribedUntil: "Abonné jusqu'au",
    trialEnds: "L'essai se termine",
    trialDayOf: "Jour {day} sur 3",
    translationPaused: "Traduction en pause",
    translationPausedDesc: "Votre essai gratuit est terminé. Les messages arrivent toujours dans leur langue d'origine.",
    unlockTranslation: "Débloquer la traduction",
    continueWithoutTranslation: "Continuer sans traduction",
    textSize: "Taille du texte",
    normalText: "Normal",
    largeText: "Grand",
    cancel: "Annuler",
    confirm: "Confirmer",
    delete: "Supprimer",
    edit: "Modifier",
    done: "Terminé",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    retry: "Réessayer",
    back: "Retour",
    next: "Suivant",
    search: "Rechercher",
    noResults: "Aucun résultat trouvé",
    searchGifs: "Rechercher des GIFs...",
    loadMore: "Charger plus",
    gif: "GIF",
    errorOccurred: "Une erreur s'est produite",
    tryAgain: "Veuillez réessayer",
    networkError: "Erreur réseau. Veuillez vérifier votre connexion.",
    sessionExpired: "Session expirée. Veuillez vous reconnecter.",
    privacyPolicy: "Politique de confidentialité",
    termsOfUse: "Conditions d'utilisation",
  },
  
  de: {
    welcome: "Willkommen bei Global Chat Connect",
    welcomeSubtitle: "Überwinden Sie Sprachbarrieren mit automatisch übersetzten Nachrichten",
    selectLanguage: "Wählen Sie Ihre bevorzugte Sprache",
    languageHint: "Alle Nachrichten werden automatisch in diese Sprache übersetzt",
    continue: "Weiter",
    signIn: "Anmelden",
    signUp: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    phone: "Telefonnummer",
    createAccount: "Konto erstellen",
    alreadyHaveAccount: "Haben Sie bereits ein Konto?",
    dontHaveAccount: "Haben Sie kein Konto?",
    signingIn: "Anmelden...",
    signingUp: "Registrieren...",
    agreeToTerms: "Ich stimme den",
    termsAndPrivacy: "Nutzungsbedingungen und Datenschutzrichtlinien zu",
    forgotPassword: "Passwort vergessen?",
    forgotPasswordHint: "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen",
    sendResetLink: "Link senden",
    sending: "Senden...",
    resetEmailSent: "E-Mail gesendet! Überprüfen Sie Ihren Posteingang.",
    invalidResetLink: "Ungültiger oder abgelaufener Link zum Zurücksetzen.",
    setNewPassword: "Neues Passwort festlegen",
    setNewPasswordHint: "Geben Sie unten Ihr neues Passwort ein",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein.",
    passwordTooShort: "Passwort muss mindestens 6 Zeichen haben.",
    passwordUpdated: "Passwort erfolgreich aktualisiert!",
    updating: "Aktualisieren...",
    updatePassword: "Passwort aktualisieren",
    phoneAlreadyInUse: "Diese Telefonnummer ist bereits registriert. Bitte verwenden Sie eine andere Nummer.",
    chats: "Chats",
    noChats: "Noch keine Chats",
    startChatting: "Starten Sie eine Unterhaltung, indem Sie einen Kontakt hinzufügen",
    deleteChat: "Chat löschen",
    deleteChatConfirm: "Sind Sie sicher, dass Sie diesen Chat löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    pinChat: "Anheften",
    unpinChat: "Lösen",
    muteChat: "Stummschalten",
    unmuteChat: "Ton an",
    chatMuted: "Stumm",
    pinnedChats: "Angeheftet",
    typeMessage: "Nachricht eingeben...",
    send: "Senden",
    online: "Online",
    offline: "Offline",
    lastSeen: "Zuletzt gesehen",
    typing: "schreibt...",
    typingPlural: "schreiben...",
    andOthers: "und {count} weitere",
    showOriginal: "Original anzeigen",
    showTranslated: "Übersetzung anzeigen",
    translatedFrom: "Übersetzt aus dem {language}",
    groupMembers: "Gruppenmitglieder",
    addMembers: "Mitglieder hinzufügen",
    removeMember: "Entfernen",
    searchMessages: "Nachrichten suchen...",
    noMessagesFound: "Keine Nachrichten gefunden",
    reply: "Antworten",
    replyingTo: "Antwort an",
    forwardMessage: "Nachricht weiterleiten",
    forward: "Weiterleiten",
    messageForwarded: "Nachricht weitergeleitet",
    deleteMessage: "Nachricht löschen",
    deleteMessageConfirm: "Sind Sie sicher, dass Sie diese Nachricht löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    messageDeleted: "Nachricht gelöscht",
    editMessage: "Nachricht bearbeiten",
    editMessageHint: "Bearbeiten Sie Ihre Nachricht unten. Die Übersetzung wird automatisch aktualisiert.",
    messageEdited: "Nachricht bearbeitet",
    edited: "bearbeitet",
    addContact: "Kontakt hinzufügen",
    enterPhoneNumber: "Telefonnummer eingeben",
    phoneNumberHint: "Gib ihre Telefonnummer ein. Wenn sie die App bereits nutzen, wirst du sofort verbunden. Wenn nicht, senden wir ihnen eine Einladung.",
    searching: "Suchen...",
    userFound: "Benutzer gefunden! Chat wird gestartet...",
    userNotFound: "Noch nicht bei Global Chat Connect.",
    sendInvite: "Einladung senden",
    inviteSent: "Einladung gesendet! 🎉",
    invitationPending: "Einladung gesendet",
    resendInvite: "Erneut senden",
    resending: "Wird gesendet...",
    inviteResent: "Einladung erneut gesendet!",
    cancelInvite: "Einladung abbrechen",
    cancelInviteConfirm: "Möchten Sie diese Einladung wirklich abbrechen?",
    inviteCancelled: "Einladung abgebrochen",
    createGroup: "Gruppe erstellen",
    groupName: "Gruppenname",
    groupNamePlaceholder: "Gruppennamen eingeben",
    selectMembers: "Mitglieder auswählen",
    noContactsYet: "Noch keine Kontakte",
    create: "Erstellen",
    creating: "Erstellen...",
    settings: "Einstellungen",
    profile: "Profil",
    profileImage: "Profilbild",
    changePhoto: "Foto ändern",
    takePhoto: "Foto aufnehmen",
    chooseFromGallery: "Aus Galerie wählen",
    preferredLanguage: "Bevorzugte Sprache",
    appearance: "Erscheinungsbild",
    theme: "Design",
    lightMode: "Hell",
    darkMode: "Dunkel",
    subscription: "Abonnement",
    manageSubscription: "Abonnement verwalten",
    cancelSubscription: "Abonnement kündigen",
    cancelSubscriptionConfirm: "Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten?",
    restorePurchases: "Käufe wiederherstellen",
    restoring: "Wiederherstellen...",
    restoreSuccess: "Käufe erfolgreich wiederhergestellt!",
    deleteAccount: "Konto löschen",
    deleteAccountConfirm: "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und alle Ihre Daten werden dauerhaft gelöscht.",
    signOut: "Abmelden",
    save: "Speichern",
    saving: "Speichern...",
    subscribe: "Abonnieren",
    subscribeTo: "Abonnieren Sie Global Chat Connect",
    subscriptionBenefits: "Unbegrenzte Nachrichten und Gruppenchats freischalten",
    freeTrial: "3-tägige kostenlose Testversion starten",
    monthly: "Monatlich",
    yearly: "Jährlich",
    lifetime: "Lebenslang",
    perMonth: "/Monat",
    perYear: "/Jahr",
    oneTime: "einmalig",
    mostPopular: "Am beliebtesten",
    bestValue: "Bestes Preis-Leistungs-Verhältnis",
    currentPlan: "Aktueller Plan",
    subscribedUntil: "Abonniert bis",
    trialEnds: "Testversion endet",
    trialDayOf: "Tag {day} von 3",
    translationPaused: "Übersetzung pausiert",
    translationPausedDesc: "Deine kostenlose Testphase ist beendet. Nachrichten kommen weiterhin in der Originalsprache an.",
    unlockTranslation: "Übersetzung freischalten",
    continueWithoutTranslation: "Ohne Übersetzung fortfahren",
    textSize: "Schriftgröße",
    normalText: "Normal",
    largeText: "Groß",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    delete: "Löschen",
    edit: "Bearbeiten",
    done: "Fertig",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    retry: "Erneut versuchen",
    back: "Zurück",
    next: "Weiter",
    search: "Suchen",
    noResults: "Keine Ergebnisse gefunden",
    searchGifs: "GIFs suchen...",
    loadMore: "Mehr laden",
    gif: "GIF",
    errorOccurred: "Ein Fehler ist aufgetreten",
    tryAgain: "Bitte versuchen Sie es erneut",
    networkError: "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
    sessionExpired: "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
    privacyPolicy: "Datenschutzrichtlinie",
    termsOfUse: "Nutzungsbedingungen",
  },
  
  it: {
    welcome: "Benvenuto su Global Chat Connect",
    welcomeSubtitle: "Abbatti le barriere linguistiche con la messaggistica tradotta automaticamente",
    selectLanguage: "Seleziona la tua lingua preferita",
    languageHint: "Tutti i messaggi saranno tradotti automaticamente in questa lingua",
    continue: "Continua",
    signIn: "Accedi",
    signUp: "Registrati",
    email: "E-mail",
    password: "Password",
    name: "Nome",
    phone: "Numero di telefono",
    createAccount: "Crea account",
    alreadyHaveAccount: "Hai già un account?",
    dontHaveAccount: "Non hai un account?",
    signingIn: "Accesso in corso...",
    signingUp: "Registrazione in corso...",
    agreeToTerms: "Accetto i",
    termsAndPrivacy: "Termini e l'Informativa sulla privacy",
    forgotPassword: "Password dimenticata?",
    forgotPasswordHint: "Inserisci la tua email e ti invieremo un link di ripristino",
    sendResetLink: "Invia link",
    sending: "Invio...",
    resetEmailSent: "Email inviata! Controlla la tua casella di posta.",
    invalidResetLink: "Link di ripristino non valido o scaduto.",
    setNewPassword: "Imposta nuova password",
    setNewPasswordHint: "Inserisci la tua nuova password qui sotto",
    newPassword: "Nuova password",
    confirmPassword: "Conferma password",
    passwordsDoNotMatch: "Le password non corrispondono.",
    passwordTooShort: "La password deve avere almeno 6 caratteri.",
    passwordUpdated: "Password aggiornata con successo!",
    updating: "Aggiornamento...",
    updatePassword: "Aggiorna password",
    phoneAlreadyInUse: "Questo numero di telefono è già registrato. Usa un numero diverso.",
    chats: "Chat",
    noChats: "Nessuna chat ancora",
    startChatting: "Inizia una conversazione aggiungendo un contatto",
    deleteChat: "Elimina chat",
    deleteChatConfirm: "Sei sicuro di voler eliminare questa chat? Questa azione non può essere annullata.",
    pinChat: "Fissa",
    unpinChat: "Rimuovi",
    muteChat: "Silenzia",
    unmuteChat: "Attiva",
    chatMuted: "Silenziato",
    pinnedChats: "Fissati",
    typeMessage: "Scrivi un messaggio...",
    send: "Invia",
    online: "Online",
    offline: "Offline",
    lastSeen: "Ultimo accesso",
    typing: "sta scrivendo...",
    typingPlural: "stanno scrivendo...",
    andOthers: "e altri {count}",
    showOriginal: "Mostra originale",
    showTranslated: "Mostra traduzione",
    translatedFrom: "Tradotto dal {language}",
    groupMembers: "Membri del gruppo",
    addMembers: "Aggiungi membri",
    removeMember: "Rimuovi",
    searchMessages: "Cerca messaggi...",
    noMessagesFound: "Nessun messaggio trovato",
    reply: "Rispondi",
    replyingTo: "In risposta a",
    forwardMessage: "Inoltra messaggio",
    forward: "Inoltra",
    messageForwarded: "Messaggio inoltrato",
    deleteMessage: "Elimina messaggio",
    deleteMessageConfirm: "Sei sicuro di voler eliminare questo messaggio? Questa azione non può essere annullata.",
    messageDeleted: "Messaggio eliminato",
    editMessage: "Modifica messaggio",
    editMessageHint: "Modifica il tuo messaggio qui sotto. La traduzione verrà aggiornata automaticamente.",
    messageEdited: "Messaggio modificato",
    edited: "modificato",
    addContact: "Aggiungi contatto",
    enterPhoneNumber: "Inserisci il numero di telefono",
    phoneNumberHint: "Inserisci il loro numero di telefono. Se usano già l'app, sarete connessi all'istante. Altrimenti, invieremo loro un invito.",
    searching: "Ricerca...",
    userFound: "Utente trovato! Avvio della chat...",
    userNotFound: "Non ancora su Global Chat Connect.",
    sendInvite: "Invia invito",
    inviteSent: "Invito inviato! 🎉",
    invitationPending: "Invito inviato",
    resendInvite: "Reinvia",
    resending: "Invio...",
    inviteResent: "Invito reinviato!",
    cancelInvite: "Annulla invito",
    cancelInviteConfirm: "Sei sicuro di voler annullare questo invito?",
    inviteCancelled: "Invito annullato",
    createGroup: "Crea gruppo",
    groupName: "Nome del gruppo",
    groupNamePlaceholder: "Inserisci il nome del gruppo",
    selectMembers: "Seleziona membri",
    noContactsYet: "Nessun contatto ancora",
    create: "Crea",
    creating: "Creazione...",
    settings: "Impostazioni",
    profile: "Profilo",
    profileImage: "Immagine profilo",
    changePhoto: "Cambia foto",
    takePhoto: "Scatta foto",
    chooseFromGallery: "Scegli dalla galleria",
    preferredLanguage: "Lingua preferita",
    appearance: "Aspetto",
    theme: "Tema",
    lightMode: "Chiaro",
    darkMode: "Scuro",
    subscription: "Abbonamento",
    manageSubscription: "Gestisci abbonamento",
    cancelSubscription: "Annulla abbonamento",
    cancelSubscriptionConfirm: "Sei sicuro di voler annullare il tuo abbonamento?",
    restorePurchases: "Ripristina acquisti",
    restoring: "Ripristino...",
    restoreSuccess: "Acquisti ripristinati con successo!",
    deleteAccount: "Elimina account",
    deleteAccountConfirm: "Sei sicuro di voler eliminare il tuo account? Questa azione non può essere annullata e tutti i tuoi dati saranno eliminati definitivamente.",
    signOut: "Esci",
    save: "Salva",
    saving: "Salvataggio...",
    subscribe: "Abbonati",
    subscribeTo: "Abbonati a Global Chat Connect",
    subscriptionBenefits: "Sblocca messaggi illimitati e chat di gruppo",
    freeTrial: "Inizia la prova gratuita di 3 giorni",
    monthly: "Mensile",
    yearly: "Annuale",
    lifetime: "A vita",
    perMonth: "/mese",
    perYear: "/anno",
    oneTime: "una tantum",
    mostPopular: "Più popolare",
    bestValue: "Miglior valore",
    currentPlan: "Piano attuale",
    subscribedUntil: "Abbonato fino al",
    trialEnds: "La prova termina",
    trialDayOf: "Giorno {day} di 3",
    translationPaused: "Traduzione sospesa",
    translationPausedDesc: "La tua prova gratuita è terminata. I messaggi continuano ad arrivare nella loro lingua originale.",
    unlockTranslation: "Sblocca la traduzione",
    continueWithoutTranslation: "Continua senza traduzione",
    textSize: "Dimensione del testo",
    normalText: "Normale",
    largeText: "Grande",
    cancel: "Annulla",
    confirm: "Conferma",
    delete: "Elimina",
    edit: "Modifica",
    done: "Fatto",
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    retry: "Riprova",
    back: "Indietro",
    next: "Avanti",
    search: "Cerca",
    noResults: "Nessun risultato trovato",
    searchGifs: "Cerca GIF...",
    loadMore: "Carica altro",
    gif: "GIF",
    errorOccurred: "Si è verificato un errore",
    tryAgain: "Per favore riprova",
    networkError: "Errore di rete. Per favore controlla la tua connessione.",
    sessionExpired: "Sessione scaduta. Per favore accedi di nuovo.",
    privacyPolicy: "Informativa sulla privacy",
    termsOfUse: "Termini di utilizzo",
  },
  
  pt: {
    welcome: "Bem-vindo ao Global Chat Connect",
    welcomeSubtitle: "Quebre as barreiras linguísticas com mensagens traduzidas automaticamente",
    selectLanguage: "Selecione seu idioma preferido",
    languageHint: "Todas as mensagens serão automaticamente traduzidas para este idioma",
    continue: "Continuar",
    signIn: "Entrar",
    signUp: "Cadastrar",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    phone: "Número de telefone",
    createAccount: "Criar conta",
    alreadyHaveAccount: "Já tem uma conta?",
    dontHaveAccount: "Não tem uma conta?",
    signingIn: "Entrando...",
    signingUp: "Cadastrando...",
    agreeToTerms: "Eu concordo com os",
    termsAndPrivacy: "Termos e Política de Privacidade",
    forgotPassword: "Esqueceu a senha?",
    forgotPasswordHint: "Digite seu e-mail e enviaremos um link de redefinição",
    sendResetLink: "Enviar link",
    sending: "Enviando...",
    resetEmailSent: "E-mail enviado! Verifique sua caixa de entrada.",
    invalidResetLink: "Link de redefinição inválido ou expirado.",
    setNewPassword: "Definir nova senha",
    setNewPasswordHint: "Digite sua nova senha abaixo",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar senha",
    passwordsDoNotMatch: "As senhas não correspondem.",
    passwordTooShort: "A senha deve ter pelo menos 6 caracteres.",
    passwordUpdated: "Senha atualizada com sucesso!",
    updating: "Atualizando...",
    updatePassword: "Atualizar senha",
    phoneAlreadyInUse: "Este número de telefone já está registrado. Por favor, use um número diferente.",
    chats: "Conversas",
    noChats: "Nenhuma conversa ainda",
    startChatting: "Inicie uma conversa adicionando um contato",
    deleteChat: "Excluir conversa",
    deleteChatConfirm: "Tem certeza de que deseja excluir esta conversa? Esta ação não pode ser desfeita.",
    pinChat: "Fixar",
    unpinChat: "Desafixar",
    muteChat: "Silenciar",
    unmuteChat: "Ativar",
    chatMuted: "Silenciado",
    pinnedChats: "Fixados",
    typeMessage: "Digite uma mensagem...",
    send: "Enviar",
    online: "Online",
    offline: "Offline",
    lastSeen: "Visto por último",
    typing: "está digitando...",
    typingPlural: "estão digitando...",
    andOthers: "e mais {count}",
    showOriginal: "Mostrar original",
    showTranslated: "Mostrar tradução",
    translatedFrom: "Traduzido do {language}",
    groupMembers: "Membros do grupo",
    addMembers: "Adicionar membros",
    removeMember: "Remover",
    searchMessages: "Pesquisar mensagens...",
    noMessagesFound: "Nenhuma mensagem encontrada",
    reply: "Responder",
    replyingTo: "Respondendo a",
    forwardMessage: "Encaminhar mensagem",
    forward: "Encaminhar",
    messageForwarded: "Mensagem encaminhada",
    deleteMessage: "Excluir mensagem",
    deleteMessageConfirm: "Tem certeza de que deseja excluir esta mensagem? Esta ação não pode ser desfeita.",
    messageDeleted: "Mensagem excluída",
    editMessage: "Editar mensagem",
    editMessageHint: "Edite sua mensagem abaixo. A tradução será atualizada automaticamente.",
    messageEdited: "Mensagem editada",
    edited: "editado",
    addContact: "Adicionar contato",
    enterPhoneNumber: "Digite o número de telefone",
    phoneNumberHint: "Digite o número de telefone deles. Se já usam o app, você será conectado instantaneamente. Se não, enviaremos um convite.",
    searching: "Pesquisando...",
    userFound: "Usuário encontrado! Iniciando conversa...",
    userNotFound: "Ainda não está no Global Chat Connect.",
    sendInvite: "Enviar convite",
    inviteSent: "Convite enviado! 🎉",
    invitationPending: "Convite enviado",
    resendInvite: "Reenviar",
    resending: "Reenviando...",
    inviteResent: "Convite reenviado!",
    cancelInvite: "Cancelar convite",
    cancelInviteConfirm: "Tem certeza de que deseja cancelar este convite?",
    inviteCancelled: "Convite cancelado",
    createGroup: "Criar grupo",
    groupName: "Nome do grupo",
    groupNamePlaceholder: "Digite o nome do grupo",
    selectMembers: "Selecionar membros",
    noContactsYet: "Nenhum contato ainda",
    create: "Criar",
    creating: "Criando...",
    settings: "Configurações",
    profile: "Perfil",
    profileImage: "Imagem do perfil",
    changePhoto: "Alterar foto",
    takePhoto: "Tirar foto",
    chooseFromGallery: "Escolher da galeria",
    preferredLanguage: "Idioma preferido",
    appearance: "Aparência",
    theme: "Tema",
    lightMode: "Claro",
    darkMode: "Escuro",
    subscription: "Assinatura",
    manageSubscription: "Gerenciar assinatura",
    cancelSubscription: "Cancelar assinatura",
    cancelSubscriptionConfirm: "Tem certeza de que deseja cancelar sua assinatura?",
    restorePurchases: "Restaurar compras",
    restoring: "Restaurando...",
    restoreSuccess: "Compras restauradas com sucesso!",
    deleteAccount: "Excluir conta",
    deleteAccountConfirm: "Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita e todos os seus dados serão excluídos permanentemente.",
    signOut: "Sair",
    save: "Salvar",
    saving: "Salvando...",
    subscribe: "Assinar",
    subscribeTo: "Assine o Global Chat Connect",
    subscriptionBenefits: "Desbloqueie mensagens ilimitadas e conversas em grupo",
    freeTrial: "Iniciar teste gratuito de 3 dias",
    monthly: "Mensal",
    yearly: "Anual",
    lifetime: "Vitalício",
    perMonth: "/mês",
    perYear: "/ano",
    oneTime: "pagamento único",
    mostPopular: "Mais popular",
    bestValue: "Melhor valor",
    currentPlan: "Plano atual",
    subscribedUntil: "Assinatura até",
    trialEnds: "O teste termina",
    trialDayOf: "Dia {day} de 3",
    translationPaused: "Tradução pausada",
    translationPausedDesc: "Seu período de teste gratuito terminou. As mensagens continuam chegando no idioma original.",
    unlockTranslation: "Desbloquear tradução",
    continueWithoutTranslation: "Continuar sem tradução",
    textSize: "Tamanho do texto",
    normalText: "Normal",
    largeText: "Grande",
    cancel: "Cancelar",
    confirm: "Confirmar",
    delete: "Excluir",
    edit: "Editar",
    done: "Concluído",
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    retry: "Tentar novamente",
    back: "Voltar",
    next: "Próximo",
    search: "Pesquisar",
    noResults: "Nenhum resultado encontrado",
    searchGifs: "Pesquisar GIFs...",
    loadMore: "Carregar mais",
    gif: "GIF",
    errorOccurred: "Ocorreu um erro",
    tryAgain: "Por favor, tente novamente",
    networkError: "Erro de rede. Por favor, verifique sua conexão.",
    sessionExpired: "Sessão expirada. Por favor, entre novamente.",
    privacyPolicy: "Política de privacidade",
    termsOfUse: "Termos de uso",
  },
  
  ru: {
    welcome: "Добро пожаловать в Global Chat Connect",
    welcomeSubtitle: "Преодолевайте языковые барьеры с автоматическим переводом сообщений",
    selectLanguage: "Выберите предпочитаемый язык",
    languageHint: "Все сообщения будут автоматически переведены на этот язык",
    continue: "Продолжить",
    signIn: "Войти",
    signUp: "Регистрация",
    email: "Электронная почта",
    password: "Пароль",
    name: "Имя",
    phone: "Номер телефона",
    createAccount: "Создать аккаунт",
    alreadyHaveAccount: "Уже есть аккаунт?",
    dontHaveAccount: "Нет аккаунта?",
    signingIn: "Вход...",
    signingUp: "Регистрация...",
    agreeToTerms: "Я принимаю",
    termsAndPrivacy: "Условия и Политику конфиденциальности",
    forgotPassword: "Забыли пароль?",
    forgotPasswordHint: "Введите email, и мы отправим ссылку для сброса",
    sendResetLink: "Отправить ссылку",
    sending: "Отправка...",
    resetEmailSent: "Письмо отправлено! Проверьте почту.",
    invalidResetLink: "Недействительная или устаревшая ссылка для сброса.",
    setNewPassword: "Установить новый пароль",
    setNewPasswordHint: "Введите новый пароль ниже",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите пароль",
    passwordsDoNotMatch: "Пароли не совпадают.",
    passwordTooShort: "Пароль должен содержать не менее 6 символов.",
    passwordUpdated: "Пароль успешно обновлен!",
    updating: "Обновление...",
    updatePassword: "Обновить пароль",
    phoneAlreadyInUse: "Этот номер телефона уже зарегистрирован. Пожалуйста, используйте другой номер.",
    chats: "Чаты",
    noChats: "Пока нет чатов",
    startChatting: "Начните разговор, добавив контакт",
    deleteChat: "Удалить чат",
    deleteChatConfirm: "Вы уверены, что хотите удалить этот чат? Это действие нельзя отменить.",
    pinChat: "Закрепить",
    unpinChat: "Открепить",
    muteChat: "Отключить",
    unmuteChat: "Включить",
    chatMuted: "Отключён",
    pinnedChats: "Закреплённые",
    typeMessage: "Введите сообщение...",
    send: "Отправить",
    online: "В сети",
    offline: "Не в сети",
    lastSeen: "Был(а) в сети",
    typing: "печатает...",
    typingPlural: "печатают...",
    andOthers: "и ещё {count}",
    showOriginal: "Показать оригинал",
    showTranslated: "Показать перевод",
    translatedFrom: "Переведено с {language}",
    groupMembers: "Участники группы",
    addMembers: "Добавить участников",
    removeMember: "Удалить",
    searchMessages: "Поиск сообщений...",
    noMessagesFound: "Сообщения не найдены",
    reply: "Ответить",
    replyingTo: "В ответ на",
    forwardMessage: "Переслать сообщение",
    forward: "Переслать",
    messageForwarded: "Сообщение переслано",
    deleteMessage: "Удалить сообщение",
    deleteMessageConfirm: "Вы уверены, что хотите удалить это сообщение? Это действие нельзя отменить.",
    messageDeleted: "Сообщение удалено",
    editMessage: "Редактировать сообщение",
    editMessageHint: "Отредактируйте сообщение ниже. Перевод будет обновлён автоматически.",
    messageEdited: "Сообщение отредактировано",
    edited: "изменено",
    addContact: "Добавить контакт",
    enterPhoneNumber: "Введите номер телефона",
    phoneNumberHint: "Введите их номер телефона. Если они уже в приложении, вы будете подключены мгновенно. Если нет — отправим им приглашение.",
    searching: "Поиск...",
    userFound: "Пользователь найден! Начинаем чат...",
    userNotFound: "Ещё нет в Global Chat Connect.",
    sendInvite: "Отправить приглашение",
    inviteSent: "Приглашение отправлено! 🎉",
    invitationPending: "Приглашение отправлено",
    resendInvite: "Отправить снова",
    resending: "Отправка...",
    inviteResent: "Приглашение отправлено повторно!",
    cancelInvite: "Отменить приглашение",
    cancelInviteConfirm: "Вы уверены, что хотите отменить это приглашение?",
    inviteCancelled: "Приглашение отменено",
    createGroup: "Создать группу",
    groupName: "Название группы",
    groupNamePlaceholder: "Введите название группы",
    selectMembers: "Выберите участников",
    noContactsYet: "Пока нет контактов",
    create: "Создать",
    creating: "Создание...",
    settings: "Настройки",
    profile: "Профиль",
    profileImage: "Фото профиля",
    changePhoto: "Изменить фото",
    takePhoto: "Сделать фото",
    chooseFromGallery: "Выбрать из галереи",
    preferredLanguage: "Предпочитаемый язык",
    appearance: "Оформление",
    theme: "Тема",
    lightMode: "Светлая",
    darkMode: "Тёмная",
    subscription: "Подписка",
    manageSubscription: "Управление подпиской",
    cancelSubscription: "Отменить подписку",
    cancelSubscriptionConfirm: "Вы уверены, что хотите отменить подписку?",
    restorePurchases: "Восстановить покупки",
    restoring: "Восстановление...",
    restoreSuccess: "Покупки успешно восстановлены!",
    deleteAccount: "Удалить аккаунт",
    deleteAccountConfirm: "Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить, и все ваши данные будут удалены навсегда.",
    signOut: "Выйти",
    save: "Сохранить",
    saving: "Сохранение...",
    subscribe: "Подписаться",
    subscribeTo: "Подпишитесь на Global Chat Connect",
    subscriptionBenefits: "Разблокируйте неограниченные сообщения и групповые чаты",
    freeTrial: "Начать 3-дневный бесплатный период",
    monthly: "Ежемесячно",
    yearly: "Ежегодно",
    lifetime: "Навсегда",
    perMonth: "/месяц",
    perYear: "/год",
    oneTime: "единоразово",
    mostPopular: "Самый популярный",
    bestValue: "Лучшая цена",
    currentPlan: "Текущий план",
    subscribedUntil: "Подписка до",
    trialEnds: "Пробный период заканчивается",
    trialDayOf: "День {day} из 3",
    translationPaused: "Перевод приостановлен",
    translationPausedDesc: "Ваш бесплатный пробный период закончился. Сообщения по-прежнему приходят на языке оригинала.",
    unlockTranslation: "Разблокировать перевод",
    continueWithoutTranslation: "Продолжить без перевода",
    textSize: "Размер текста",
    normalText: "Обычный",
    largeText: "Крупный",
    cancel: "Отмена",
    confirm: "Подтвердить",
    delete: "Удалить",
    edit: "Редактировать",
    done: "Готово",
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успех",
    retry: "Повторить",
    back: "Назад",
    next: "Далее",
    search: "Поиск",
    noResults: "Ничего не найдено",
    searchGifs: "Поиск GIF...",
    loadMore: "Загрузить ещё",
    gif: "GIF",
    errorOccurred: "Произошла ошибка",
    tryAgain: "Пожалуйста, попробуйте снова",
    networkError: "Ошибка сети. Проверьте подключение.",
    sessionExpired: "Сессия истекла. Войдите снова.",
    privacyPolicy: "Политика конфиденциальности",
    termsOfUse: "Условия использования",
  },
  
  ja: {
    welcome: "Global Chat Connectへようこそ",
    welcomeSubtitle: "自動翻訳メッセージで言語の壁を打ち破ろう",
    selectLanguage: "お好みの言語を選択してください",
    languageHint: "すべてのメッセージはこの言語に自動翻訳されます",
    continue: "続行",
    signIn: "ログイン",
    signUp: "新規登録",
    email: "メールアドレス",
    password: "パスワード",
    name: "名前",
    phone: "電話番号",
    createAccount: "アカウント作成",
    alreadyHaveAccount: "すでにアカウントをお持ちですか？",
    dontHaveAccount: "アカウントをお持ちでないですか？",
    signingIn: "ログイン中...",
    signingUp: "登録中...",
    agreeToTerms: "同意します",
    termsAndPrivacy: "利用規約とプライバシーポリシー",
    forgotPassword: "パスワードをお忘れですか？",
    forgotPasswordHint: "メールアドレスを入力してください。リセットリンクを送信します",
    sendResetLink: "リンクを送信",
    sending: "送信中...",
    resetEmailSent: "メールを送信しました！受信箱を確認してください。",
    invalidResetLink: "無効または期限切れのリセットリンクです。",
    setNewPassword: "新しいパスワードを設定",
    setNewPasswordHint: "以下に新しいパスワードを入力してください",
    newPassword: "新しいパスワード",
    confirmPassword: "パスワードを確認",
    passwordsDoNotMatch: "パスワードが一致しません。",
    passwordTooShort: "パスワードは6文字以上である必要があります。",
    passwordUpdated: "パスワードが正常に更新されました！",
    updating: "更新中...",
    updatePassword: "パスワードを更新",
    phoneAlreadyInUse: "この電話番号はすでに登録されています。別の番号を使用してください。",
    chats: "チャット",
    noChats: "チャットはまだありません",
    startChatting: "連絡先を追加して会話を始めましょう",
    deleteChat: "チャットを削除",
    deleteChatConfirm: "このチャットを削除してもよろしいですか？この操作は取り消せません。",
    pinChat: "ピン留め",
    unpinChat: "ピン解除",
    muteChat: "ミュート",
    unmuteChat: "ミュート解除",
    chatMuted: "ミュート中",
    pinnedChats: "ピン留め済み",
    typeMessage: "メッセージを入力...",
    send: "送信",
    online: "オンライン",
    offline: "オフライン",
    lastSeen: "最終オンライン",
    typing: "入力中...",
    typingPlural: "が入力中...",
    andOthers: "他{count}人",
    showOriginal: "原文を表示",
    showTranslated: "翻訳を表示",
    translatedFrom: "{language}から翻訳",
    groupMembers: "グループメンバー",
    addMembers: "メンバーを追加",
    removeMember: "削除",
    searchMessages: "メッセージを検索...",
    noMessagesFound: "メッセージが見つかりません",
    reply: "返信",
    replyingTo: "返信先",
    forwardMessage: "メッセージを転送",
    forward: "転送",
    messageForwarded: "メッセージを転送しました",
    deleteMessage: "メッセージを削除",
    deleteMessageConfirm: "このメッセージを削除してもよろしいですか？この操作は元に戻せません。",
    messageDeleted: "メッセージが削除されました",
    editMessage: "メッセージを編集",
    editMessageHint: "下のメッセージを編集してください。翻訳は自動的に更新されます。",
    messageEdited: "メッセージが編集されました",
    edited: "編集済み",
    addContact: "連絡先を追加",
    enterPhoneNumber: "電話番号を入力",
    phoneNumberHint: "相手の電話番号を入力してください。すでにアプリを使っていれば即座につながります。そうでなければ招待を送ります。",
    searching: "検索中...",
    userFound: "ユーザーが見つかりました！チャットを開始します...",
    userNotFound: "まだGlobal Chat Connectを使っていません。",
    sendInvite: "招待を送る",
    inviteSent: "招待を送りました！🎉",
    invitationPending: "招待送信済み",
    resendInvite: "再送信",
    resending: "送信中...",
    inviteResent: "招待を再送信しました！",
    cancelInvite: "招待をキャンセル",
    cancelInviteConfirm: "この招待をキャンセルしてもよろしいですか？",
    inviteCancelled: "招待がキャンセルされました",
    createGroup: "グループを作成",
    groupName: "グループ名",
    groupNamePlaceholder: "グループ名を入力",
    selectMembers: "メンバーを選択",
    noContactsYet: "連絡先はまだありません",
    create: "作成",
    creating: "作成中...",
    settings: "設定",
    profile: "プロフィール",
    profileImage: "プロフィール画像",
    changePhoto: "写真を変更",
    takePhoto: "写真を撮る",
    chooseFromGallery: "ギャラリーから選択",
    preferredLanguage: "言語設定",
    appearance: "外観",
    theme: "テーマ",
    lightMode: "ライト",
    darkMode: "ダーク",
    subscription: "サブスクリプション",
    manageSubscription: "サブスクリプション管理",
    cancelSubscription: "サブスクリプションをキャンセル",
    cancelSubscriptionConfirm: "サブスクリプションをキャンセルしてもよろしいですか？",
    restorePurchases: "購入を復元",
    restoring: "復元中...",
    restoreSuccess: "購入が正常に復元されました！",
    deleteAccount: "アカウントを削除",
    deleteAccountConfirm: "アカウントを削除してもよろしいですか？この操作は取り消せず、すべてのデータが完全に削除されます。",
    signOut: "ログアウト",
    save: "保存",
    saving: "保存中...",
    subscribe: "登録する",
    subscribeTo: "Global Chat Connectに登録",
    subscriptionBenefits: "無制限のメッセージとグループチャットをアンロック",
    freeTrial: "3日間の無料トライアルを開始",
    monthly: "月額",
    yearly: "年額",
    lifetime: "永久",
    perMonth: "/月",
    perYear: "/年",
    oneTime: "一回払い",
    mostPopular: "最も人気",
    bestValue: "最もお得",
    currentPlan: "現在のプラン",
    subscribedUntil: "サブスクリプション期限",
    trialEnds: "トライアル終了",
    trialDayOf: "3日間のうち{day}日目",
    translationPaused: "翻訳が一時停止されました",
    translationPausedDesc: "無料トライアルが終了しました。メッセージは引き続き元の言語で届いています。",
    unlockTranslation: "翻訳を有効化",
    continueWithoutTranslation: "翻訳なしで続ける",
    textSize: "文字サイズ",
    normalText: "標準",
    largeText: "大きい",
    cancel: "キャンセル",
    confirm: "確認",
    delete: "削除",
    edit: "編集",
    done: "完了",
    loading: "読み込み中...",
    error: "エラー",
    success: "成功",
    retry: "再試行",
    back: "戻る",
    next: "次へ",
    search: "検索",
    noResults: "結果が見つかりません",
    searchGifs: "GIF を検索...",
    loadMore: "もっと読み込む",
    gif: "GIF",
    errorOccurred: "エラーが発生しました",
    tryAgain: "もう一度お試しください",
    networkError: "ネットワークエラー。接続を確認してください。",
    sessionExpired: "セッションの有効期限が切れました。再度ログインしてください。",
    privacyPolicy: "プライバシーポリシー",
    termsOfUse: "利用規約",
  },
  
  ko: {
    welcome: "Global Chat Connect에 오신 것을 환영합니다",
    welcomeSubtitle: "자동 번역 메시지로 언어 장벽을 허물어보세요",
    selectLanguage: "선호하는 언어를 선택하세요",
    languageHint: "모든 메시지가 이 언어로 자동 번역됩니다",
    continue: "계속",
    signIn: "로그인",
    signUp: "회원가입",
    email: "이메일",
    password: "비밀번호",
    name: "이름",
    phone: "전화번호",
    createAccount: "계정 만들기",
    alreadyHaveAccount: "이미 계정이 있으신가요?",
    dontHaveAccount: "계정이 없으신가요?",
    signingIn: "로그인 중...",
    signingUp: "가입 중...",
    agreeToTerms: "동의합니다",
    termsAndPrivacy: "이용약관 및 개인정보처리방침",
    forgotPassword: "비밀번호를 잊으셨나요?",
    forgotPasswordHint: "이메일을 입력하시면 재설정 링크를 보내드립니다",
    sendResetLink: "링크 보내기",
    sending: "전송 중...",
    resetEmailSent: "이메일을 보냈습니다! 받은편지함을 확인하세요.",
    invalidResetLink: "유효하지 않거나 만료된 재설정 링크입니다.",
    setNewPassword: "새 비밀번호 설정",
    setNewPasswordHint: "아래에 새 비밀번호를 입력하세요",
    newPassword: "새 비밀번호",
    confirmPassword: "비밀번호 확인",
    passwordsDoNotMatch: "비밀번호가 일치하지 않습니다.",
    passwordTooShort: "비밀번호는 최소 6자 이상이어야 합니다.",
    passwordUpdated: "비밀번호가 성공적으로 업데이트되었습니다!",
    updating: "업데이트 중...",
    updatePassword: "비밀번호 업데이트",
    phoneAlreadyInUse: "이 전화번호는 이미 등록되어 있습니다. 다른 번호를 사용해 주세요.",
    chats: "채팅",
    noChats: "아직 채팅이 없습니다",
    startChatting: "연락처를 추가하여 대화를 시작하세요",
    deleteChat: "채팅 삭제",
    deleteChatConfirm: "이 채팅을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
    pinChat: "고정",
    unpinChat: "고정 해제",
    muteChat: "알림 끄기",
    unmuteChat: "알림 켜기",
    chatMuted: "알림 꺼짐",
    pinnedChats: "고정됨",
    typeMessage: "메시지 입력...",
    send: "보내기",
    online: "온라인",
    offline: "오프라인",
    lastSeen: "마지막 접속",
    typing: "입력 중...",
    typingPlural: "입력 중...",
    andOthers: "외 {count}명",
    showOriginal: "원문 보기",
    showTranslated: "번역 보기",
    translatedFrom: "{language}에서 번역됨",
    groupMembers: "그룹 멤버",
    addMembers: "멤버 추가",
    removeMember: "삭제",
    searchMessages: "메시지 검색...",
    noMessagesFound: "메시지를 찾을 수 없습니다",
    reply: "답장",
    replyingTo: "답장 대상",
    forwardMessage: "메시지 전달",
    forward: "전달",
    messageForwarded: "메시지가 전달되었습니다",
    deleteMessage: "메시지 삭제",
    deleteMessageConfirm: "이 메시지를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    messageDeleted: "메시지가 삭제되었습니다",
    editMessage: "메시지 편집",
    editMessageHint: "아래에서 메시지를 편집하세요. 번역이 자동으로 업데이트됩니다.",
    messageEdited: "메시지가 편집되었습니다",
    edited: "편집됨",
    addContact: "연락처 추가",
    enterPhoneNumber: "전화번호 입력",
    phoneNumberHint: "전화번호를 입력하세요. 이미 앱을 사용 중이면 즉시 연결됩니다. 그렇지 않으면 초대장을 보내드립니다.",
    searching: "검색 중...",
    userFound: "사용자를 찾았습니다! 채팅을 시작합니다...",
    userNotFound: "아직 Global Chat Connect에 없습니다.",
    sendInvite: "초대 보내기",
    inviteSent: "초대장을 보냈습니다! 🎉",
    invitationPending: "초대 전송됨",
    resendInvite: "재전송",
    resending: "전송 중...",
    inviteResent: "초대가 재전송되었습니다!",
    cancelInvite: "초대 취소",
    cancelInviteConfirm: "이 초대를 취소하시겠습니까?",
    inviteCancelled: "초대가 취소되었습니다",
    createGroup: "그룹 만들기",
    groupName: "그룹 이름",
    groupNamePlaceholder: "그룹 이름 입력",
    selectMembers: "멤버 선택",
    noContactsYet: "아직 연락처가 없습니다",
    create: "만들기",
    creating: "생성 중...",
    settings: "설정",
    profile: "프로필",
    profileImage: "프로필 이미지",
    changePhoto: "사진 변경",
    takePhoto: "사진 촬영",
    chooseFromGallery: "갤러리에서 선택",
    preferredLanguage: "선호 언어",
    appearance: "외관",
    theme: "테마",
    lightMode: "라이트",
    darkMode: "다크",
    subscription: "구독",
    manageSubscription: "구독 관리",
    cancelSubscription: "구독 취소",
    cancelSubscriptionConfirm: "구독을 취소하시겠습니까?",
    restorePurchases: "구매 복원",
    restoring: "복원 중...",
    restoreSuccess: "구매가 성공적으로 복원되었습니다!",
    deleteAccount: "계정 삭제",
    deleteAccountConfirm: "계정을 삭제하시겠습니까? 이 작업은 취소할 수 없으며 모든 데이터가 영구적으로 삭제됩니다.",
    signOut: "로그아웃",
    save: "저장",
    saving: "저장 중...",
    subscribe: "구독하기",
    subscribeTo: "Global Chat Connect 구독",
    subscriptionBenefits: "무제한 메시지와 그룹 채팅 잠금 해제",
    freeTrial: "3일 무료 체험 시작",
    monthly: "월간",
    yearly: "연간",
    lifetime: "평생",
    perMonth: "/월",
    perYear: "/년",
    oneTime: "일회성",
    mostPopular: "가장 인기",
    bestValue: "최고의 가치",
    currentPlan: "현재 플랜",
    subscribedUntil: "구독 기간",
    trialEnds: "체험 종료",
    trialDayOf: "3일 중 {day}일째",
    translationPaused: "번역이 일시 중지됨",
    translationPausedDesc: "무료 체험이 종료되었습니다. 메시지가 계속 원래 언어로 도착하고 있습니다.",
    unlockTranslation: "번역 잠금 해제",
    continueWithoutTranslation: "번역 없이 계속",
    textSize: "텍스트 크기",
    normalText: "보통",
    largeText: "크게",
    cancel: "취소",
    confirm: "확인",
    delete: "삭제",
    edit: "편집",
    done: "완료",
    loading: "로딩 중...",
    error: "오류",
    success: "성공",
    retry: "다시 시도",
    back: "뒤로",
    next: "다음",
    search: "검색",
    noResults: "결과를 찾을 수 없습니다",
    searchGifs: "GIF 검색...",
    loadMore: "더 보기",
    gif: "GIF",
    errorOccurred: "오류가 발생했습니다",
    tryAgain: "다시 시도해 주세요",
    networkError: "네트워크 오류입니다. 연결을 확인해 주세요.",
    sessionExpired: "세션이 만료되었습니다. 다시 로그인해 주세요.",
    privacyPolicy: "개인정보처리방침",
    termsOfUse: "이용약관",
  },
  
  zh: {
    welcome: "欢迎使用 Global Chat Connect",
    welcomeSubtitle: "通过自动翻译消息打破语言障碍",
    selectLanguage: "选择您的首选语言",
    languageHint: "所有消息将自动翻译成此语言",
    continue: "继续",
    signIn: "登录",
    signUp: "注册",
    email: "电子邮件",
    password: "密码",
    name: "姓名",
    phone: "电话号码",
    createAccount: "创建账户",
    alreadyHaveAccount: "已有账户？",
    dontHaveAccount: "没有账户？",
    signingIn: "登录中...",
    signingUp: "注册中...",
    agreeToTerms: "我同意",
    termsAndPrivacy: "条款和隐私政策",
    forgotPassword: "忘记密码？",
    forgotPasswordHint: "输入您的电子邮件，我们将发送重置链接",
    sendResetLink: "发送链接",
    sending: "发送中...",
    resetEmailSent: "邮件已发送！请检查您的收件箱。",
    invalidResetLink: "无效或过期的重置链接。",
    setNewPassword: "设置新密码",
    setNewPasswordHint: "在下方输入您的新密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    passwordsDoNotMatch: "密码不匹配。",
    passwordTooShort: "密码必须至少6个字符。",
    passwordUpdated: "密码更新成功！",
    updating: "更新中...",
    updatePassword: "更新密码",
    phoneAlreadyInUse: "此电话号码已被注册。请使用其他号码。",
    chats: "聊天",
    noChats: "暂无聊天",
    startChatting: "添加联系人开始对话",
    deleteChat: "删除聊天",
    deleteChatConfirm: "确定要删除此聊天吗？此操作无法撤销。",
    pinChat: "置顶",
    unpinChat: "取消置顶",
    muteChat: "静音",
    unmuteChat: "取消静音",
    chatMuted: "已静音",
    pinnedChats: "已置顶",
    typeMessage: "输入消息...",
    send: "发送",
    online: "在线",
    offline: "离线",
    lastSeen: "最后在线",
    typing: "正在输入...",
    typingPlural: "正在输入...",
    andOthers: "等{count}人",
    showOriginal: "显示原文",
    showTranslated: "显示翻译",
    translatedFrom: "从{language}翻译",
    groupMembers: "群组成员",
    addMembers: "添加成员",
    removeMember: "移除",
    searchMessages: "搜索消息...",
    noMessagesFound: "未找到消息",
    reply: "回复",
    replyingTo: "回复给",
    forwardMessage: "转发消息",
    forward: "转发",
    messageForwarded: "消息已转发",
    deleteMessage: "删除消息",
    deleteMessageConfirm: "确定要删除此消息吗？此操作无法撤销。",
    messageDeleted: "消息已删除",
    editMessage: "编辑消息",
    editMessageHint: "在下方编辑您的消息。翻译将自动更新。",
    messageEdited: "消息已编辑",
    edited: "已编辑",
    addContact: "添加联系人",
    enterPhoneNumber: "输入电话号码",
    phoneNumberHint: "输入他们的电话号码。如果他们已经在使用该应用，您将立即连接。如果没有，我们会发送邀请。",
    searching: "搜索中...",
    userFound: "找到用户！正在开始聊天...",
    userNotFound: "尚未加入 Global Chat Connect。",
    sendInvite: "发送邀请",
    inviteSent: "邀请已发送！🎉",
    invitationPending: "邀请已发送",
    resendInvite: "重新发送",
    resending: "发送中...",
    inviteResent: "邀请已重新发送！",
    cancelInvite: "取消邀请",
    cancelInviteConfirm: "确定要取消此邀请吗？",
    inviteCancelled: "邀请已取消",
    createGroup: "创建群组",
    groupName: "群组名称",
    groupNamePlaceholder: "输入群组名称",
    selectMembers: "选择成员",
    noContactsYet: "暂无联系人",
    create: "创建",
    creating: "创建中...",
    settings: "设置",
    profile: "个人资料",
    profileImage: "头像",
    changePhoto: "更换照片",
    takePhoto: "拍照",
    chooseFromGallery: "从相册选择",
    preferredLanguage: "首选语言",
    appearance: "外观",
    theme: "主题",
    lightMode: "浅色",
    darkMode: "深色",
    subscription: "订阅",
    manageSubscription: "管理订阅",
    cancelSubscription: "取消订阅",
    cancelSubscriptionConfirm: "确定要取消订阅吗？",
    restorePurchases: "恢复购买",
    restoring: "恢复中...",
    restoreSuccess: "购买恢复成功！",
    deleteAccount: "删除账户",
    deleteAccountConfirm: "确定要删除账户吗？此操作无法撤销，所有数据将被永久删除。",
    signOut: "退出登录",
    save: "保存",
    saving: "保存中...",
    subscribe: "订阅",
    subscribeTo: "订阅 Global Chat Connect",
    subscriptionBenefits: "解锁无限消息和群聊",
    freeTrial: "开始3天免费试用",
    monthly: "月付",
    yearly: "年付",
    lifetime: "终身",
    perMonth: "/月",
    perYear: "/年",
    oneTime: "一次性",
    mostPopular: "最受欢迎",
    bestValue: "最超值",
    currentPlan: "当前套餐",
    subscribedUntil: "订阅到期",
    trialEnds: "试用结束",
    trialDayOf: "第{day}天，共3天",
    translationPaused: "翻译已暂停",
    translationPausedDesc: "您的免费试用已结束。消息仍在以原始语言送达。",
    unlockTranslation: "解锁翻译",
    continueWithoutTranslation: "不使用翻译继续",
    textSize: "字体大小",
    normalText: "正常",
    largeText: "大",
    cancel: "取消",
    confirm: "确认",
    delete: "删除",
    edit: "编辑",
    done: "完成",
    loading: "加载中...",
    error: "错误",
    success: "成功",
    retry: "重试",
    back: "返回",
    next: "下一步",
    search: "搜索",
    noResults: "未找到结果",
    searchGifs: "搜索 GIF...",
    loadMore: "加载更多",
    gif: "GIF",
    errorOccurred: "发生错误",
    tryAgain: "请重试",
    networkError: "网络错误，请检查您的连接。",
    sessionExpired: "会话已过期，请重新登录。",
    privacyPolicy: "隐私政策",
    termsOfUse: "使用条款",
  },
  
  ar: {
    welcome: "مرحباً بك في Global Chat Connect",
    welcomeSubtitle: "تجاوز حواجز اللغة مع الترجمة التلقائية للرسائل",
    selectLanguage: "اختر لغتك المفضلة",
    languageHint: "ستتم ترجمة جميع الرسائل تلقائياً إلى هذه اللغة",
    continue: "متابعة",
    signIn: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    phone: "رقم الهاتف",
    createAccount: "إنشاء حساب",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    dontHaveAccount: "ليس لديك حساب؟",
    signingIn: "جاري تسجيل الدخول...",
    signingUp: "جاري التسجيل...",
    agreeToTerms: "أوافق على",
    termsAndPrivacy: "الشروط وسياسة الخصوصية",
    forgotPassword: "نسيت كلمة المرور؟",
    forgotPasswordHint: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين",
    sendResetLink: "إرسال الرابط",
    sending: "جاري الإرسال...",
    resetEmailSent: "تم إرسال البريد! تحقق من صندوق الوارد.",
    invalidResetLink: "رابط إعادة التعيين غير صالح أو منتهي الصلاحية.",
    setNewPassword: "تعيين كلمة مرور جديدة",
    setNewPasswordHint: "أدخل كلمة المرور الجديدة أدناه",
    newPassword: "كلمة مرور جديدة",
    confirmPassword: "تأكيد كلمة المرور",
    passwordsDoNotMatch: "كلمات المرور غير متطابقة.",
    passwordTooShort: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
    passwordUpdated: "تم تحديث كلمة المرور بنجاح!",
    updating: "جاري التحديث...",
    updatePassword: "تحديث كلمة المرور",
    phoneAlreadyInUse: "رقم الهاتف هذا مسجل بالفعل. يرجى استخدام رقم مختلف.",
    chats: "المحادثات",
    noChats: "لا توجد محادثات بعد",
    startChatting: "ابدأ محادثة بإضافة جهة اتصال",
    deleteChat: "حذف المحادثة",
    deleteChatConfirm: "هل أنت متأكد من حذف هذه المحادثة؟ لا يمكن التراجع عن هذا الإجراء.",
    pinChat: "تثبيت",
    unpinChat: "إلغاء التثبيت",
    muteChat: "كتم",
    unmuteChat: "إلغاء الكتم",
    chatMuted: "مكتوم",
    pinnedChats: "مثبتة",
    typeMessage: "اكتب رسالة...",
    send: "إرسال",
    online: "متصل",
    offline: "غير متصل",
    lastSeen: "آخر ظهور",
    typing: "يكتب...",
    typingPlural: "يكتبون...",
    andOthers: "و{count} آخرون",
    showOriginal: "عرض الأصلي",
    showTranslated: "عرض الترجمة",
    translatedFrom: "مترجم من {language}",
    groupMembers: "أعضاء المجموعة",
    addMembers: "إضافة أعضاء",
    removeMember: "إزالة",
    searchMessages: "البحث في الرسائل...",
    noMessagesFound: "لم يتم العثور على رسائل",
    reply: "رد",
    replyingTo: "الرد على",
    forwardMessage: "إعادة توجيه الرسالة",
    forward: "إعادة توجيه",
    messageForwarded: "تم إعادة توجيه الرسالة",
    deleteMessage: "حذف الرسالة",
    deleteMessageConfirm: "هل أنت متأكد من حذف هذه الرسالة؟ لا يمكن التراجع عن هذا الإجراء.",
    messageDeleted: "تم حذف الرسالة",
    editMessage: "تعديل الرسالة",
    editMessageHint: "عدّل رسالتك أدناه. سيتم تحديث الترجمة تلقائياً.",
    messageEdited: "تم تعديل الرسالة",
    edited: "معدّل",
    addContact: "إضافة جهة اتصال",
    enterPhoneNumber: "أدخل رقم الهاتف",
    phoneNumberHint: "أدخل رقم هاتفهم. إذا كانوا يستخدمون التطبيق بالفعل، سيتم توصيلك فوراً. وإلا، سنرسل لهم دعوة.",
    searching: "جاري البحث...",
    userFound: "تم العثور على المستخدم! بدء المحادثة...",
    userNotFound: "ليس على Global Chat Connect بعد.",
    sendInvite: "إرسال الدعوة",
    inviteSent: "تم إرسال الدعوة! 🎉",
    invitationPending: "تم إرسال الدعوة",
    resendInvite: "إعادة الإرسال",
    resending: "جارٍ الإرسال...",
    inviteResent: "تمت إعادة إرسال الدعوة!",
    cancelInvite: "إلغاء الدعوة",
    cancelInviteConfirm: "هل أنت متأكد أنك تريد إلغاء هذه الدعوة؟",
    inviteCancelled: "تم إلغاء الدعوة",
    createGroup: "إنشاء مجموعة",
    groupName: "اسم المجموعة",
    groupNamePlaceholder: "أدخل اسم المجموعة",
    selectMembers: "اختر الأعضاء",
    noContactsYet: "لا توجد جهات اتصال بعد",
    create: "إنشاء",
    creating: "جاري الإنشاء...",
    settings: "الإعدادات",
    profile: "الملف الشخصي",
    profileImage: "صورة الملف الشخصي",
    changePhoto: "تغيير الصورة",
    takePhoto: "التقاط صورة",
    chooseFromGallery: "اختيار من المعرض",
    preferredLanguage: "اللغة المفضلة",
    appearance: "المظهر",
    theme: "السمة",
    lightMode: "فاتح",
    darkMode: "داكن",
    subscription: "الاشتراك",
    manageSubscription: "إدارة الاشتراك",
    cancelSubscription: "إلغاء الاشتراك",
    cancelSubscriptionConfirm: "هل أنت متأكد من إلغاء اشتراكك؟",
    restorePurchases: "استعادة المشتريات",
    restoring: "جاري الاستعادة...",
    restoreSuccess: "تم استعادة المشتريات بنجاح!",
    deleteAccount: "حذف الحساب",
    deleteAccountConfirm: "هل أنت متأكد من حذف حسابك؟ لا يمكن التراجع عن هذا الإجراء وسيتم حذف جميع بياناتك نهائياً.",
    signOut: "تسجيل الخروج",
    save: "حفظ",
    saving: "جاري الحفظ...",
    subscribe: "اشترك",
    subscribeTo: "اشترك في Global Chat Connect",
    subscriptionBenefits: "افتح رسائل غير محدودة ومحادثات جماعية",
    freeTrial: "ابدأ الفترة التجريبية المجانية لمدة 3 أيام",
    monthly: "شهري",
    yearly: "سنوي",
    lifetime: "مدى الحياة",
    perMonth: "/شهر",
    perYear: "/سنة",
    oneTime: "دفعة واحدة",
    mostPopular: "الأكثر شعبية",
    bestValue: "أفضل قيمة",
    currentPlan: "الخطة الحالية",
    subscribedUntil: "مشترك حتى",
    trialEnds: "تنتهي الفترة التجريبية",
    trialDayOf: "اليوم {day} من 3",
    translationPaused: "الترجمة متوقفة",
    translationPausedDesc: "انتهت فترة التجربة المجانية. لا تزال الرسائل تصل بلغتها الأصلية.",
    unlockTranslation: "فتح الترجمة",
    continueWithoutTranslation: "المتابعة بدون ترجمة",
    textSize: "حجم الخط",
    normalText: "عادي",
    largeText: "كبير",
    cancel: "إلغاء",
    confirm: "تأكيد",
    delete: "حذف",
    edit: "تعديل",
    done: "تم",
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجاح",
    retry: "إعادة المحاولة",
    back: "رجوع",
    next: "التالي",
    search: "بحث",
    noResults: "لم يتم العثور على نتائج",
    searchGifs: "...البحث عن صور GIF",
    loadMore: "تحميل المزيد",
    gif: "GIF",
    errorOccurred: "حدث خطأ",
    tryAgain: "يرجى المحاولة مرة أخرى",
    networkError: "خطأ في الشبكة. يرجى التحقق من اتصالك.",
    sessionExpired: "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    privacyPolicy: "سياسة الخصوصية",
    termsOfUse: "شروط الاستخدام",
  },
  
  hi: {
    welcome: "Global Chat Connect में आपका स्वागत है",
    welcomeSubtitle: "स्वचालित अनुवादित संदेशों के साथ भाषा की बाधाओं को तोड़ें",
    selectLanguage: "अपनी पसंदीदा भाषा चुनें",
    languageHint: "सभी संदेश स्वचालित रूप से इस भाषा में अनुवादित होंगे",
    continue: "जारी रखें",
    signIn: "साइन इन करें",
    signUp: "साइन अप करें",
    email: "ईमेल",
    password: "पासवर्ड",
    name: "नाम",
    phone: "फोन नंबर",
    createAccount: "खाता बनाएं",
    alreadyHaveAccount: "पहले से खाता है?",
    dontHaveAccount: "खाता नहीं है?",
    signingIn: "साइन इन हो रहा है...",
    signingUp: "साइन अप हो रहा है...",
    agreeToTerms: "मैं सहमत हूं",
    termsAndPrivacy: "नियम और गोपनीयता नीति",
    forgotPassword: "पासवर्ड भूल गए?",
    forgotPasswordHint: "अपना ईमेल दर्ज करें और हम आपको रीसेट लिंक भेजेंगे",
    sendResetLink: "लिंक भेजें",
    sending: "भेज रहा है...",
    resetEmailSent: "ईमेल भेजा गया! अपना इनबॉक्स जांचें।",
    invalidResetLink: "अमान्य या समाप्त रीसेट लिंक।",
    setNewPassword: "नया पासवर्ड सेट करें",
    setNewPasswordHint: "नीचे अपना नया पासवर्ड दर्ज करें",
    newPassword: "नया पासवर्ड",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    passwordsDoNotMatch: "पासवर्ड मेल नहीं खाते।",
    passwordTooShort: "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।",
    passwordUpdated: "पासवर्ड सफलतापूर्वक अपडेट हो गया!",
    updating: "अपडेट हो रहा है...",
    updatePassword: "पासवर्ड अपडेट करें",
    phoneAlreadyInUse: "यह फ़ोन नंबर पहले से पंजीकृत है। कृपया एक अलग नंबर का उपयोग करें।",
    chats: "चैट",
    noChats: "अभी कोई चैट नहीं",
    startChatting: "संपर्क जोड़कर बातचीत शुरू करें",
    deleteChat: "चैट हटाएं",
    deleteChatConfirm: "क्या आप वाकई इस चैट को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
    pinChat: "पिन करें",
    unpinChat: "अनपिन करें",
    muteChat: "म्यूट करें",
    unmuteChat: "अनम्यूट करें",
    chatMuted: "म्यूट है",
    pinnedChats: "पिन किए गए",
    typeMessage: "संदेश लिखें...",
    send: "भेजें",
    online: "ऑनलाइन",
    offline: "ऑफलाइन",
    lastSeen: "अंतिम बार देखा गया",
    typing: "टाइप कर रहा है...",
    typingPlural: "टाइप कर रहे हैं...",
    andOthers: "और {count} अन्य",
    showOriginal: "मूल दिखाएं",
    showTranslated: "अनुवाद दिखाएं",
    translatedFrom: "{language} से अनुवादित",
    groupMembers: "समूह के सदस्य",
    addMembers: "सदस्य जोड़ें",
    removeMember: "हटाएं",
    searchMessages: "संदेश खोजें...",
    noMessagesFound: "कोई संदेश नहीं मिला",
    reply: "उत्तर दें",
    replyingTo: "को उत्तर",
    forwardMessage: "संदेश अग्रेषित करें",
    forward: "अग्रेषित करें",
    messageForwarded: "संदेश अग्रेषित किया गया",
    deleteMessage: "संदेश हटाएं",
    deleteMessageConfirm: "क्या आप वाकई इस संदेश को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
    messageDeleted: "संदेश हटाया गया",
    editMessage: "संदेश संपादित करें",
    editMessageHint: "नीचे अपना संदेश संपादित करें। अनुवाद स्वचालित रूप से अपडेट हो जाएगा।",
    messageEdited: "संदेश संपादित किया गया",
    edited: "संपादित",
    addContact: "संपर्क जोड़ें",
    enterPhoneNumber: "फोन नंबर दर्ज करें",
    phoneNumberHint: "उनका फोन नंबर दर्ज करें। अगर वे पहले से ऐप पर हैं, तो आप तुरंत जुड़ जाएंगे। अगर नहीं, तो हम उन्हें निमंत्रण भेजेंगे।",
    searching: "खोज रहा है...",
    userFound: "उपयोगकर्ता मिल गया! चैट शुरू हो रही है...",
    userNotFound: "अभी Global Chat Connect पर नहीं हैं।",
    sendInvite: "निमंत्रण भेजें",
    inviteSent: "निमंत्रण भेज दिया! 🎉",
    invitationPending: "आमंत्रण भेजा गया",
    resendInvite: "पुनः भेजें",
    resending: "भेज रहे हैं...",
    inviteResent: "आमंत्रण पुनः भेजा गया!",
    cancelInvite: "आमंत्रण रद्द करें",
    cancelInviteConfirm: "क्या आप वाकई इस आमंत्रण को रद्द करना चाहते हैं?",
    inviteCancelled: "आमंत्रण रद्द किया गया",
    createGroup: "समूह बनाएं",
    groupName: "समूह का नाम",
    groupNamePlaceholder: "समूह का नाम दर्ज करें",
    selectMembers: "सदस्य चुनें",
    noContactsYet: "अभी कोई संपर्क नहीं",
    create: "बनाएं",
    creating: "बना रहा है...",
    settings: "सेटिंग्स",
    profile: "प्रोफाइल",
    profileImage: "प्रोफाइल फोटो",
    changePhoto: "फोटो बदलें",
    takePhoto: "फोटो लें",
    chooseFromGallery: "गैलरी से चुनें",
    preferredLanguage: "पसंदीदा भाषा",
    appearance: "दिखावट",
    theme: "थीम",
    lightMode: "लाइट",
    darkMode: "डार्क",
    subscription: "सदस्यता",
    manageSubscription: "सदस्यता प्रबंधित करें",
    cancelSubscription: "सदस्यता रद्द करें",
    cancelSubscriptionConfirm: "क्या आप वाकई अपनी सदस्यता रद्द करना चाहते हैं?",
    restorePurchases: "खरीदारी पुनर्स्थापित करें",
    restoring: "पुनर्स्थापित हो रहा है...",
    restoreSuccess: "खरीदारी सफलतापूर्वक पुनर्स्थापित!",
    deleteAccount: "खाता हटाएं",
    deleteAccountConfirm: "क्या आप वाकई अपना खाता हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती और आपका सारा डेटा स्थायी रूप से हटा दिया जाएगा।",
    signOut: "साइन आउट",
    save: "सहेजें",
    saving: "सहेज रहा है...",
    subscribe: "सदस्यता लें",
    subscribeTo: "Global Chat Connect की सदस्यता लें",
    subscriptionBenefits: "असीमित संदेश और समूह चैट अनलॉक करें",
    freeTrial: "3-दिन का मुफ्त ट्रायल शुरू करें",
    monthly: "मासिक",
    yearly: "वार्षिक",
    lifetime: "आजीवन",
    perMonth: "/माह",
    perYear: "/वर्ष",
    oneTime: "एक बार",
    mostPopular: "सबसे लोकप्रिय",
    bestValue: "सबसे अच्छा मूल्य",
    currentPlan: "वर्तमान योजना",
    subscribedUntil: "सदस्यता तक",
    trialEnds: "ट्रायल समाप्त",
    trialDayOf: "3 में से {day}वाँ दिन",
    translationPaused: "अनुवाद रुका हुआ है",
    translationPausedDesc: "आपका मुफ़्त ट्रायल समाप्त हो गया है। संदेश अभी भी अपनी मूल भाषा में आ रहे हैं।",
    unlockTranslation: "अनुवाद अनलॉक करें",
    continueWithoutTranslation: "अनुवाद के बिना जारी रखें",
    textSize: "टेक्स्ट आकार",
    normalText: "सामान्य",
    largeText: "बड़ा",
    cancel: "रद्द करें",
    confirm: "पुष्टि करें",
    delete: "हटाएं",
    edit: "संपादित करें",
    done: "हो गया",
    loading: "लोड हो रहा है...",
    error: "त्रुटि",
    success: "सफलता",
    retry: "पुनः प्रयास करें",
    back: "वापस",
    next: "अगला",
    search: "खोजें",
    noResults: "कोई परिणाम नहीं मिला",
    searchGifs: "GIF खोजें...",
    loadMore: "और लोड करें",
    gif: "GIF",
    errorOccurred: "एक त्रुटि हुई",
    tryAgain: "कृपया पुनः प्रयास करें",
    networkError: "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।",
    sessionExpired: "सत्र समाप्त हो गया। कृपया फिर से साइन इन करें।",
    privacyPolicy: "गोपनीयता नीति",
    termsOfUse: "उपयोग की शर्तें",
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
export type LanguageCode = keyof typeof translations;

export const getTranslation = (lang: string, key: TranslationKey): string => {
  const langTranslations = translations[lang as LanguageCode] || translations.en;
  return langTranslations[key] || translations.en[key] || key;
};
